// ============ SUBSCRIPTION TOGGLE LOGIC ============
  document.querySelectorAll('.sub-toggle, .bundle-sub').forEach(group=>{
    group.querySelectorAll('.sub-option, .opt').forEach(opt=>{
      opt.addEventListener('click', ()=>{
        group.querySelectorAll('.sub-option, .opt').forEach(o=>o.classList.remove('active'));
        opt.classList.add('active');
      });
    });
  });

  // ============ EXIT INTENT MODAL ============
  // Strategy: trigger on mouse-leave (desktop) and rapid-scroll-up (mobile proxy for back-button)
  const modal = document.getElementById('exitModal');
  const modalClose = document.getElementById('modalClose');
  let shownThisSession = false;

  function showModal(){
    if(shownThisSession) return;
    if(sessionStorage.getItem('rn_exit_shown')) return;
    shownThisSession = true;
    sessionStorage.setItem('rn_exit_shown','1');
    modal.classList.add('show');
  }
  function hideModal(){ modal.classList.remove('show'); }

  // Desktop: trigger on mouse leaving viewport upward
  document.addEventListener('mouseleave', e=>{
    if(e.clientY <= 0) showModal();
  });

  // Mobile: trigger after 25 seconds OR rapid scroll-up after some engagement
  let scrollEngaged = false;
  let lastScroll = 0;
  setTimeout(()=>{ if(window.innerWidth < 980 && scrollEngaged) showModal(); }, 25000);
  window.addEventListener('scroll', ()=>{
    const y = window.scrollY;
    if(y > 600) scrollEngaged = true;
    if(scrollEngaged && y < lastScroll - 80 && window.innerWidth < 980) showModal();
    lastScroll = y;
  });

  modalClose.addEventListener('click', hideModal);
  modal.addEventListener('click', e=>{ if(e.target === modal) hideModal(); });
  document.addEventListener('keydown', e=>{ if(e.key === 'Escape') hideModal(); });

  document.getElementById('modalForm').addEventListener('submit', e=>{
    e.preventDefault();

    // e.target.innerHTML = '<div style="text-align:center;padding:14px 0;color:var(--leaf);font-weight:600">✓ Check your inbox. The Gut Reset Guide is on its way.</div>';
    // setTimeout(hideModal, 2400);

    subscribeToKlaviyo();


  });


  // FUNCTION SUBMIT FORM //
  async function subscribeToKlaviyo() {

  const email = document.getElementById("email").value;
  const rawPhone = document.getElementById("phone").value;

  const phone = formatPHPhone(rawPhone);

  try {

    const response = await fetch(
      "https://a.klaviyo.com/client/subscriptions/?company_id=StrDKY",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "revision": "2024-02-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email,
                    phone_number: phone
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "X345TW"
                }
              }
            }
          }
        })
      }
    );

    // DON'T force JSON parsing
    const text = await response.text();

    console.log("Response Status:", response.status);
    console.log("Response Body:", text);

    if (response.ok) {
      console.log("Subscribed successfully");
	    const modalForm = document.getElementById('modalForm');
      modalForm.innerHTML = '<div style="text-align:center;padding:14px 0;color:var(--leaf);font-weight:600">✓ Check your inbox. The Healthy Gut Guide is on its way.</div>';
      setTimeout(hideModal, 2400);
    } else {
      console.error("Klaviyo Error:", text);
    }
  } catch(err) {
    console.error("Request Failed:", err);
  }
}

function formatPHPhone(phone) {

  phone = phone.replace(/\D/g, '');

  if (phone.startsWith('0')) {
    return '+63' + phone.substring(1);
  }

  if (phone.startsWith('63')) {
    return '+' + phone;
  }

  return phone;
}

  // ============ SCROLL REVEAL ============
  const io = new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('section').forEach(s=>{
    s.classList.add('reveal');
    io.observe(s);
  });

  // ============ STICKY CTA: only show after hero scrolls past on mobile ============
  const sticky = document.querySelector('.sticky-cta');
  window.addEventListener('scroll', ()=>{
    if(window.innerWidth >= 980) return;
    sticky.style.transform = window.scrollY > 500 ? 'translateY(0)' : 'translateY(110%)';
  });


  // == event click carts 
  document
    .getElementById('btn_fulltimeexp')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_full_experience').href =
        'https://richnuts.com/cart/add?id=46156505645244&selling_plan=6302269628&attributes[source]=dave_blast_2026';

  });

  document
    .getElementById('btn_onetimepurchase')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_full_experience').href =
        'https://richnuts.com/cart/add?id=46156505645244&attributes[source]=dave_blast_2026';

  });

  // --- SWEET STARTER --- //
  document
    .getElementById('opt_ss_subscribe')
    .addEventListener('click', function () {

      document.getElementById('add_to_card_sweet_starter').href =
        'https://richnuts.com/cart/add?id=46156505579708&selling_plan=6302269628&attributes[source]=dave_blast_2026';

  });

  document
    .getElementById('opt_ss_one_time')
    .addEventListener('click', function () {

      document.getElementById('add_to_card_sweet_starter').href =
        'https://richnuts.com/cart/add?id=46156505579708&attributes[source]=dave_blast_2026';

  });

  // --- FULL EXPERIENCE --- //
  document
    .getElementById('opt_fe_subscribe')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_get_full_experience2').href =
        'https://richnuts.com/cart/add?id=46156505645244&selling_plan=6302269628&attributes[source]=dave_blast_2026';

  });

  document
    .getElementById('opt_fe_one_time')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_get_full_experience2').href =
        'https://richnuts.com/cart/add?id=46156505645244&attributes[source]=dave_blast_2026';

  });

  // --- SAVORY STARTER --- //
  document
    .getElementById('opt_cs_subscribe')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_savory_starter').href =
        'https://richnuts.com/cart/add?id=46156505612476&selling_plan=6302269628&attributes[source]=dave_blast_2026';

  });

  document
    .getElementById('opt_cs_one_time')
    .addEventListener('click', function () {

      document.getElementById('add_to_cart_savory_starter').href =
        'https://richnuts.com/cart/add?id=46156505612476&attributes[source]=dave_blast_2026';

  });